<template>
  <div class="main-box mh-a">
    <!-- <div class="p-r">
      <img width="100%" src="/static/img/solution/jjfa.png" />
      <div class="p-a text-info pt100 c-white text-center fs24">
        <p class="lh100 fs28 fw-s">{{ text }}</p>
        <ul class="flex w520px mh-a fs24 j-s-b">
          <li class="mh10" v-for="t in iconArr" :key="t">{{ t }}</li>
        </ul>
      </div>
    </div> -->

    <!-- <el-row>
      <el-col class="text-center " :xs="8" :sm="6" v-for="(item, index) in solutionData" :key="`${index}_solution`"
        @click.native="jumpPage(item.index)">
        <div class="border-r solution-item mv20 c-pointer">
          <img class="w160px" :src="`/static/img/programme/${item.img}.png`"
            :alt="$t(`programme.programme${item.index}`)" />
          <h4 class="fs16 lh30 c-g-d fw-b">
            {{ $t(`programme.${item.index}`) }}
          </h4>
        </div>
      </el-col>
    </el-row> -->


    <div class="solution-box">
      <router-link class="item" :to="item.link" v-for="(item, idx) in data" :key="idx">
        <div class="hd">
          <img :src="item.img" alt="">
        </div>
        <div class="bd">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "iristarSolution",
  data() {
    return {
      text: "以客户需求为导向，提供全栈式解决方案",
      iconArr: ["精准识别", "安全防护", "异常检测", "降本增效"],
      data: [

        {
          img: '/static/img/programme/s2.png',
          title: '企业级车间智能化服务',
          link: '/solution-details/4',
          desc: '企业级车间智能化服务，依托于中国科学院自动化研究所三十余年技术积累，基于智能感知、生物识别、视频监控AI分析，打造集智慧化运营分析、智能监控、人员管理、生产支持系统于一体的整体服务方案。',
        },
        {
          img: '/static/img/programme/s3.png',
          title: '企业级实验室智能化服务',
          link: '/solution-details/5',
          desc: '企业级实验室智能化服务，基于计算机视觉、自然语言处理、生物识别、AI智能分析等人工智能最新技术，打造人员管理、物料管理、设备管理、实验管理于一体的整体服务方案',
        },
        {
          img: '/static/img/programme/s4.png',
          title: '科研级实验室智能化服务',
          link: '/solution-details/6',
          desc: '针对从行需求出发，以安全管理、流程管理、操作合规管理、实验记录管理为核心，以计算机视觉、自然语言处理、生物识别、AI智能分析等人工智能最新技术为依托，设计整套智能化服务方案',
        },
        {
          img: '/static/img/programme/s5.png',
          title: '公共服务平台智能化服务',
          link: '/solution-details/7',
          desc: '以公共服务为目标，以操作合规管理、实验记录管理、安全管理为核心，基于计算机视觉、自然语言处理、生物识别、AI智能分析等技术，设计符合公共服务的智能化服务方案',
        },
        // {
        //   img: '/static/img/programme/26.png',
        //   title: '医疗实验室智能化服务',
        //   link: '/solution-details/8',
        //   desc: '以公共服务为目标，以操作合规管理、实验记录管理、安全管理为核心，基于计算机视觉、自然语言处理、生物识别、AI智能分析等技术，设计符合公共服务的智能化服务方案',
        // },
        {
          img: '/static/img/programme/programme9.png',
          link: '/solution-details/9',
          title: '定制化服务',
          desc: '从行业客户需求出发，将大模型、AIGC、计算机视觉、自然语言处理等人工智能最新技术进行融合，设计整套智能化解决方案',
        },

      ]
    };
  },
  methods: {
    jumpPage(index) {
      let path = "";
      switch (index) {
        case 6:
          path = `/iristar-solution-factory`;
          break;
        case 8:
          path = `/iristar-solution-swzy`;
          break;
        default:
          path = `/solution-details/${index}`;
      }
      this.$router.push({
        path,
      });
    },
  },
  props: {
    solutionData: {
      type: Array,
      default: () => {
        return [
          // {
          //   index: 1,
          //   label: "智慧通关",
          //   img: "tg",
          // },
          // {
          //   index: 2,
          //   label: "智慧安防",
          //   img: "af",
          // },
          // {
          //   index: 3,
          //   label: "智慧工地",
          //   img: "gd",
          // },
          {
            index: 4,
            label: "智慧金融",
            img: "jr",
          },
          {
            index: 5,
            label: "智慧考试",
            img: "ks",
          },
          {
            index: 6,
            label: "智慧工厂",
            img: "gc",
          },
          {
            index: 7,
            label: "智慧园区",
            img: "yq",
          },
          {
            index: 8,
            label: "智慧医药",
            img: "yy",
          }, {
            index: 9,
            label: "智慧医药",
            img: "yy",
          },
        ];
      },
    },
  },
};
</script>

<style lang="less">
.solution-box {
  margin: 20px;

  .item {
    display: block;
    padding: 20px;
    color: #333;
    text-decoration: none;
    margin-bottom: 10px;

    .bd {
      flex: 1;

      .title {
        font-size: 17px;
        font-weight: 600;
        margin: 10px 0 20px;
      }

      .desc {
        line-height: 1.5;
        font-size: 15px;
      }
    }
  }
}

@media (min-width: 768px) {
  .solution-box {
    margin: 50px auto;

    .item {
      display: block;
      padding: 20px 100px;
      display: flex;
      color: #333;
      text-decoration: none;
      align-content: center;
      justify-content: center;
      align-items: center;
      border: 1px solid #fff;
      cursor: pointer;

      &:hover {
        img {
          transform: scale(1.3);
        }
      }

      .hd {
        width: 300px;
        margin-right: 50px;
        margin-right: 50px;
        overflow: hidden;

        img {
          transition: all 1s;
          width: 100%;
        }
      }

      .bd {
        flex: 1;

        .title {
          font-size: 19px;
          font-weight: 600;
          margin: 10px 0 20px;
        }

        .desc {
          line-height: 2;
          font-size: 17px;
        }
      }
    }
  }

}
</style>
